import React from 'react';
import {
  Paper,
  Typography,
  Box,
} from '@mui/material';
import {
  Info,
  Security,
  Warning,
} from '@mui/icons-material';

export {}; // Make this a module

interface Board {
  policies?: any;
  rules?: string;
  cancellationPolicy?: string;
}

interface PoliciesSectionProps {
  board: Board | null;
}

const PoliciesSection: React.FC<PoliciesSectionProps> = ({ board }) => {
  if (!board?.policies && !board?.rules && !board?.cancellationPolicy) return null;

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
        📋 Políticas y Reglas
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {board.policies && (
          <Box>
            <Typography variant="h6" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Info color="primary" />
              Políticas de Servicio
            </Typography>
            <Box sx={{ pl: 4 }}>
              {board.policies.checkIn && (
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  🕐 <strong>Check-in:</strong> {board.policies.checkIn}
                </Typography>
              )}
              {board.policies.checkOut && (
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  🕐 <strong>Check-out:</strong> {board.policies.checkOut}
                </Typography>
              )}
              {board.policies.pets && (
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  🐕 <strong>Mascotas:</strong> {board.policies.pets}
                </Typography>
              )}
              {board.policies.cancellation && (
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  ❌ <strong>Cancelación:</strong> {board.policies.cancellation}
                </Typography>
              )}
            </Box>
          </Box>
        )}

        {board.rules && (
          <Box>
            <Typography variant="h6" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Security color="warning" />
              Reglas Importantes
            </Typography>
            <Typography variant="body1" sx={{ pl: 4, fontStyle: 'italic' }}>
              {board.rules}
            </Typography>
          </Box>
        )}

        {board.cancellationPolicy && (
          <Box>
            <Typography variant="h6" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Warning color="error" />
              Política de Cancelación
            </Typography>
            <Typography variant="body1" sx={{ pl: 4 }}>
              {board.cancellationPolicy}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default PoliciesSection;